export default [
    { id: 'active', label: 'Active', style: { width: '5%' } },
    { id: 'name', label: 'Name', style: { width: '25%' } },
    { id: 'description', label: 'Description' },
    { id: 'dateCreated', label: 'Date created' },
    { id: 'discountType', label: 'Type' },
    { id: 'discount', label: 'Amount' },
    { id: 'actions', label: 'Actions' }
];
